var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestOutRounded2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1799_8029)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_1799_8029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6341 36.4746C22.0876 35.9356 22.0876 35.0537 22.6341 34.5147C23.17 33.9861 24.0312 33.9861 24.5672 34.5147L27.2406 37.1518V27.228C27.2406 26.4548 27.8674 25.828 28.6406 25.828C29.4138 25.828 30.0406 26.4548 30.0406 27.228V37.1518L32.7141 34.5147C33.25 33.9861 34.1112 33.9861 34.6472 34.5147C35.1936 35.0537 35.1936 35.9356 34.6472 36.4746L28.6406 42.3994L22.6341 36.4746Z",
    fill: "#E87A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.011 40.9018C17.6103 41.5126 16.8061 41.7106 16.1676 41.3556L9.6002 37.7044C8.7602 37.152 8.2002 36.3234 8.2002 35.3568V18.5091C8.2002 17.5425 8.7602 16.5758 9.6002 16.1615L23.6002 8.0139C24.0202 7.7377 24.4402 7.59961 25.0002 7.59961C25.5602 7.59961 25.9802 7.7377 26.4002 8.0139L40.4002 16.1615C41.2402 16.7139 41.8002 17.5425 41.8002 18.5091V25.5329C41.8002 26.3061 41.1734 26.9329 40.4002 26.9329C39.627 26.9329 39.0002 26.3061 39.0002 25.5329V18.5091L25.0002 10.3615L11.0002 18.5091V35.3568L17.5134 38.9132C18.2282 39.3035 18.4577 40.2208 18.011 40.9018Z",
    fill: "url(#paint1_linear_1799_8029)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1799_8029",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1799_8029"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1799_8029",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1799_8029",
    x1: 49,
    y1: 25,
    x2: 0.999998,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1799_8029",
    x1: 41.8002,
    y1: 24.7925,
    x2: 8.20019,
    y2: 24.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestOutRounded2);
export default __webpack_public_path__ + "static/media/RequestOutRounded2.f1d65fefea9762c917bd19afe4ee0f54.svg";
export { ForwardRef as ReactComponent };